import service from '@/service'
import format from 'date-fns/format'
import { LeadStatus, LEAD_TIMEOUT } from '@/constants'

// interface Lead {
//   id: nanoid
//   date: string
//   status: Status
//   data: Payload
//   locale: string
//   error?: {
//    message: string
//    data?: { lead_status: string; date_of_first_contact: string, potential: string }
//   }
//   req: Promise | null // store only
// }

const state = {
  items: []
}

const getters = {
  failedLeads(state) {
    return state.items.filter(lead =>
      [
        LeadStatus.FAILED,
        LeadStatus.INTERRUPTED,
        LeadStatus.DUPLICATE
      ].includes(lead.status)
    )
  }
}

const mutations = {
  addLead(state, lead) {
    state.items = [lead, ...state.items]
  },
  updateLead(state, { id, ...fields }) {
    state.items = state.items.map(lead =>
      lead.id === id ? { ...lead, ...fields } : lead
    )
  }
}

const actions = {
  createLead({ state, commit }, { data, locale, id }) {
    const lead = state.items.find(item => item.id === id)

    return new Promise(async (resolve, reject) => {
      const req = service.flights
        .complaintLite(data, locale)
        .then(res => {
          commit('updateLead', { id, status: LeadStatus.SUCCESS })
          resolve(res)
        })
        .catch(err => {
          // TODO: Better error handling, refactor AddCase.vue error handling
          const { data = {} } = err.response || {}

          const status =
            data.data && data.data.lead_status === '1'
              ? LeadStatus.DUPLICATE
              : LeadStatus.FAILED

          const error = {
            message: err.response
              ? data.detail ||
                'Wystąpił problem po stronie serwera. Proszę spróbować później.'
              : 'Wystąpił problem z połączeniem.',
            data: data.data
          }

          commit('updateLead', { id, status, error })
          reject(err)
        })

      if (lead) {
        commit('updateLead', {
          status: LeadStatus.IN_PROGRESS,
          data,
          locale,
          id,
          req
        })
      } else {
        commit('addLead', {
          id,
          date: format(new Date(), 'dd.MM.yyyy HH:mm'),
          status: LeadStatus.IN_PROGRESS,
          data,
          locale,
          req
        })
      }

      setTimeout(() => resolve(), LEAD_TIMEOUT)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
